import Layout from '@/layout'

const RailwayExportRouter = {
  path: '/RailwayExport',
  component: Layout,
  redirect: 'noredirect',
  name: 'RailwayExport',
  meta: {
    title: '铁路出口',
    icon: 'daohang-ziliaoguanli'
  },
  children: [
    {
      path: 'ReBooking',
      component: () => import('@/views/cargo/v0/RailwayExport/reBooking'),
      name: 'ReBooking',
      meta: { title: '铁路操作' },
      roles: ['module_RailwayExport']
    },
    {
      path: 'BookingVerify',
      component: () => import('@/views/cargo/v0/RailwayExport/bookingVerify'),
      name: 'ReBookingVerify',
      meta: { title: '订舱预审' },
      roles: ['module_RailwayBookingVerify']
    },
    {
      path: 'FmRailwayBoxTube',
      component: () => import('@/views/cargo/v0/RailwayExport/fmRailwayBoxTube'),
      name: 'FmRailwayBoxTube',
      meta: { title: '箱管' },
      roles: ['module_fmRailwayBoxTube']
    },
    {
      path: 'ImportCharge',
      component: () => import('@/views/cargo/v0/RailwayExport/ImportCharge/index'),
      name: 'ImportCharge',
      meta: { title: '批量导入费用(铁出)' },
      roles: ['module_fmImportChargeRE']
    },
    {
      path: 'QueryContainer',
      component: () => import('@/views/cargo/v0/RailwayExport/QueryContainer/index'),
      name: 'QueryContainer',
      meta: { title: '集装箱查询' },
      roles: ['module_fmQueryContainer']
    },
    {
      path: 'Warehousing',
      component: () => import('@/views/cargo/v0/RailwayExport/Warehousing/index'),
      name: 'Warehousing',
      meta: { title: '仓储' },
      roles: ['module_RailwayExportWarehouse']
    }
  ]
}

export default RailwayExportRouter
